module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-sea-7e0a506a676addd8d808955e8fb1bc5a.png";